export default __webpack_public_path__ + "static/media/cat.9075ff1d.svg";